// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__rYb0s","rowContainer":"styles_rowContainer__EwiGQ","iconWrapper":"styles_iconWrapper__rZHtU","title":"styles_title__T4oB1","value":"styles_value__I7TBB"};